import * as React from "react";
import { UitkCard, UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { viewContext } from "../CheckPrices";
import { UitkLayoutFlex } from "uitk-react-layout-flex";

interface ContainerProps {
  id: string;
  fmId: number;
  fmTitleId?: number;
  title: string;
  view: string;
}

export const Container: React.FC<ContainerProps> = props => {
  const view = React.useContext(viewContext);

  switch (view) {
    case "row":
      return <RowViewContainer {...props} />;
    default:
      return <DefaultContainer {...props} />;
  }
};

const DefaultContainer: React.FC<Omit<ContainerProps, "view">> = ({
  children,
  fmId,
  fmTitleId,
  id,
  title
}) => (
  <div
    className="CheckPrices all-y-padding-three"
    id={id}
    data-fm={fmId}
    data-fm-title-id={fmTitleId}
  >
    <UitkCard>
      <UitkCardContent>
        <UitkCardTextSegment className="all-y-padding-four">
          <h2 className="uitk-type-heading-600">{title}</h2>
        </UitkCardTextSegment>
        {children}
      </UitkCardContent>
    </UitkCard>
  </div>
);

const RowViewContainer: React.FC<Omit<ContainerProps, "view">> = ({
  children,
  fmId,
  fmTitleId,
  id,
  title
}) => (
  <section
    className="uitk-card uitk-cell uitk-flex-column all-x-padding-twelve all-y-padding-three all-y-margin-three uitk-flat-border-top uitk-flat-border-bottom"
    id={id}
    data-fm={fmId}
    data-fm-title-id={fmTitleId}
  >
    <h2 className="uitk-type-heading-500">{title}</h2>
    <UitkLayoutFlex space="two" wrap="wrap">
      {children}
    </UitkLayoutFlex>
  </section>
);
